export const MONOBLOCK_STYLES = [
  {
    id: "mb-01",
    name: "M1",
    slug: "m1",
    img: "/assets/styles/m1.jpg",
    blurb: "Sharp Y-spoke, lightweight cutouts.",
  },
  {
    id: "mb-02",
    name: "M2",
    slug: "m2",
    img: "/assets/styles/m2.jpg",
    blurb: "Directional Aero-Lip for motion & 10 spoke cut center.",
  },
  {
    id: "mb-03",
    name: "M3",
    slug: "m3",
    img: "/assets/styles/m3.jpg",
    blurb: "Cleanest Y-spoke time has ever blessed us with.",
  },
  {
    id: "mb-04",
    name: "M4",
    slug: "m4",
    img: "/assets/styles/m4.jpg",
    blurb: "Ultra-Light double 5-spoke, track-focused.",
  },
  {
    id: "mb-05",
    name: "M5",
    slug: "m5",
    img: "/assets/styles/m5.jpg",
    blurb: "Flat Aero-Lip with 10 spoke star.",
  },
  {
    id: "mb-06",
    name: "M6",
    slug: "m6",
    img: "/assets/styles/m6.jpg",
    blurb: "Ultra-Light 10 spoke timeless silhouette.",
  },
  {
    id: "mb-07",
    name: "M7",
    slug: "m7",
    img: "/assets/styles/m7.jpg",
    blurb: "The OG BMW & PORSCHE favorite.",
  },
  {
    id: "mb-08",
    name: "M8",
    slug: "m8",
    img: "/assets/styles/m8.jpg",
    blurb: "New Gen China Plate Wheels.",
  },
  {
    id: "mb-09",
    name: "M9",
    slug: "m9",
    img: "/assets/styles/m9.jpg",
    blurb: "Staright Aero-Lip with wiremesh face.",
  },
];
